import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, BrowserRouter } from "react-router-dom";
import { SigninSignup } from "./pages/signinsignup/SigninSignup";
import { SetupAccount } from "./pages/signinsignup/SetupAccount";
import { Footer } from "./components/footer/Footer";
// Preserved for future restoration — replaced by the new landing page below.
// import { Home } from "./pages/home/Home";
import { Landing } from "./pages/landing/Landing";
import NotFound from "./pages/notFound/NotFound";
import { SolutionsPage } from "./pages/solutions/SolutionsPage";
import { PricingPage } from "./pages/pricing/PricingPage";
import { ContactUsPage } from "./pages/contactUs/ContactUsPage";
import Admin from "./pages/admin/Admin";
import ReportAnalysisPage from "./components/reportAnalysis/ReportAnalysisPage";
import { Navbar } from "./components/navbar/Navbar";
import { Users } from "./components/users/Users";
import { Restaurant } from "./components/restsaurant/Restaurant";
import { Reports } from "./components/reports/Reports";
import LegalDocument from "./pages/legal/LegalDocument";
import { Analysis } from "./components/analysis/Analysis";
import { Campains } from "./components/campains/Campains";
import { Guidlines } from "./components/guidlines/Guidlines";
import { BranchesFaults } from "./components/branchesFaults/BranchesFaults";
import Menu from "./components/menu/Menu";
import { Logs } from "./components/logs/Logs";
import SaledItems from "./components/saledItems/SaledItems";
import Operation from "./components/operation/Operation";
import OnboardingPage from "./components/onboarding/Onboarding";
import CRMTable from "./components/crm/crm";
import Support from "./components/support/Support";
import CopilotAdmin from "./components/copilotAdmin/CopilotAdmin";
import StoreOnboardingPage from "./pages/storeOnboarding/StoreOnboarding";
import StoreOnboardingAdmin from "./components/onboardingpage/StoreOnboardingAdmin/StoreOnboardingAdmin";
import MailInbox from "./components/mailInbox/MailInbox";
import LudNotifications from "./components/ludNotifications/LudNotifications";
import LudDocuments from "./components/ludDocuments/LudDocuments";
import LudConnect from "./components/ludConnect/LudConnect";
import LudDashboard from "./components/ludDashboard/LudDashboard/LudDashboard";
import CashierDocumentation from "./components/cashier/CashierDocumentation";
import DocumentationAdmin from "./components/cashier/admin/DocumentationAdmin";
import BillingEntry from "./components/billing/BillingEntry";
import CopilotWidget from "./components/copilot/CopilotWidget";
import { RouteGuard } from "./access/components/RouteGuard";
import { AccessEpoch } from "./access/components/AccessEpoch";
import { AUTH_AREA_POLICY, ROUTE_POLICIES } from "./access/core/routePolicies";
// Loaded on demand so its code and CSS stay out of the production bundle.
const TestUi = lazy(() => import("./TestUi"));
const PAGES = {
  "delivery-documentation": CashierDocumentation,
  "delivery-documentation-admin": DocumentationAdmin,
  billing: BillingEntry,
  support: Support,
  copilot: CopilotAdmin,
  notifications: LudNotifications,
  guidelines: Guidlines,
  faults: BranchesFaults,
  menu: Menu,
  "lud-connect": LudConnect,
  restaurants: Restaurant,
  "saled-items": SaledItems,
  "lud-documents": LudDocuments,
  onboarding: OnboardingPage,
  reports: Reports,
  operation: Operation,
  campaignRecord: Campains,
  analysis: Analysis,
  "store-onboarding-admin": StoreOnboardingAdmin,
  "lud-dashboard": LudDashboard,
  lud: ReportAnalysisPage,
  crm: CRMTable,
  users: Users,
  logs: Logs,
  "mail-inbox": MailInbox,
};

// Nested under /auth/*: paths are relative to the shell route.
const SHELL_ROUTES = ROUTE_POLICIES.filter(
  (route) => PAGES[route.id] && route.path.startsWith("/auth/"),
);

function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<Landing />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contactus" element={<ContactUsPage />} />
          {/* Legacy alias — kept working for old links/bookmarks */}
          <Route
            path="/subscription"
            element={<Navigate to="/contactus" replace />}
          />
          <Route path="/signin" element={<SigninSignup />} />
          <Route path="/setup-account" element={<SetupAccount />} />
          <Route path="/terms" element={<LegalDocument documentId="terms" />} />
          <Route path="/feedback" element={<LegalDocument documentId="feedback" />} />
          <Route path="/privacy" element={<LegalDocument documentId="privacy" />} />
          <Route path="/refund" element={<LegalDocument documentId="refund" />} />
          {/* Every protected route is declared in access/core/routePolicies. */}
          <Route
            path="/auth/*"
            element={
              <RouteGuard
                permission={AUTH_AREA_POLICY.permission}
                alsoPermission={AUTH_AREA_POLICY.or}
                redirectTo="/"
              >
                <AccessEpoch>
                  <Admin />
                </AccessEpoch>
              </RouteGuard>
            }
          >
            {SHELL_ROUTES.map((route) => {
              const Page = PAGES[route.id];
              return (
                <Route
                  key={route.id}
                  path={route.path.slice("/auth/".length)}
                  element={
                    <RouteGuard permission={route.permission} alsoPermission={route.or}>
                      <Page />
                    </RouteGuard>
                  }
                />
              );
            })}
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path="/auth/store-onboarding"
            element={
              <RouteGuard permission="onboarding.store.view" redirectTo="/">
                <StoreOnboardingPage />
              </RouteGuard>
            }
          />
          <Route
            path="/test-ui"
            element={
              <RouteGuard permission="app.testUi">
                <AccessEpoch>
                  <Admin />
                </AccessEpoch>
              </RouteGuard>
            }
          >
            <Route
              index
              element={
                <Suspense fallback={null}>
                  <TestUi />
                </Suspense>
              }
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <CopilotWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
